export enum ApiKeysEnum {
  GET_USER = 'GET_USER',
  EDIT_USER_PROFILE = 'EDIT_USER_PROFILE',
  GET_LANGUAGES = 'GET_LANGUAGS',
}
